import { createContext } from 'react';

interface DimensionContextType {
  column?: 3 | 4;
  enableAction?: boolean;
}

const DimensionContext = createContext<DimensionContextType>({
  column: 4,
  enableAction: true,
});

export default DimensionContext;
